<template>
  <div>
    <ion-card v-if="elapsedTime">
      <ion-card-header>
        <div class="title">
          <ion-card-title class="text-20">
            <span class="text-20">Elapsed time</span>
          </ion-card-title>
        </div>
      </ion-card-header>
      <ion-card-content>
        <p>{{ elapsedTime }}</p>
      </ion-card-content>
    </ion-card>
  </div>
</template>

<script>
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent } from "@ionic/vue";
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import ApiService from "../../common/service.api";

export default defineComponent({
  name: "ElapsedTimeCard",
  components: { IonCard, IonCardHeader, IonCardTitle, IonCardContent },
  setup() {
    const elapsedTime = ref("");
    const timer = ref(null);
    const store = useStore();

    const calculateElapsedTime = (checkInTime) => {
      if (!checkInTime) {
        elapsedTime.value = "0h 0m 0s";
        return;
      }

      const checkInDate = new Date(checkInTime);
      const now = new Date();
      let diffMs = now - checkInDate;

      if (diffMs < 0) diffMs = 0;

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      elapsedTime.value = `${hours}h ${minutes}m ${seconds}s`;
    };

    const fetchData = async () => {
      try {
        const idUser = store.getters["user/getUserData"]?.id;
        if (!idUser) {
          return;
        }

        const response = await ApiService.get(`UserCheckInOut/Gets/0/${idUser}`);
        const checkInRecord = response.data
          .filter((record) => record.checkin === true)
          .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate))[0];

        if (checkInRecord) {
          calculateElapsedTime(checkInRecord.eventDate);
          timer.value = setInterval(() => {
            calculateElapsedTime(checkInRecord.eventDate);
          }, 1000);
        } else {
          console.log('error');
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    onMounted(() => {
      fetchData();
    });

    onBeforeUnmount(() => {
      if (timer.value) {
        clearInterval(timer.value);
      }
    });

    return {
      elapsedTime,
    };
  },
});
</script>
<style lang="scss" scoped>
ion-card {
  --background: var(--ion-color-primary);
  color: var(--text-color-light);
  margin-bottom: 1rem;
  width: 100%;
  ion-card-title {
    color: var(--text-color-light);
  }
}

.title {
  display: block;
  clear: both;
}

ion-card {
  margin-bottom: 1rem;
  width: 90%;
}
</style>
